import { TableList } from "../components/TableList";

export default function Contacts() {
  return (
    <div className="container py-3">
      <div className="row justify-content-center">
        <h2>Directory</h2>
        <TableList />
      </div>
    </div>
  );
}